export default [
    {"Output": "Per Pupil Debt", "Index": 0},
    {"Output": "Total Debt", "Index": 1},
    {"Output": "Per Pupil Debt", "Index": 2},
    {"Output": "Total Debt", "Index": 3},
    {"Output": "Percent Debt", "Index": 4}
]